// extracted by mini-css-extract-plugin
export var footer = "_mq-0";
export var inherit = "_mq-1";
export var input = "_mq-2";
export var modalContent = "_mq-3";
export var quillEditor = "_mq-4";
export var subtitle = "_mq-5";